export default {
  ApiClientManagementTitle: 'API Client Management',
  buttonNewApiClient: 'New API Client',
  clientID: 'Client ID',
  clientName: 'Client Name',
  contactEmail: 'Contact Email',
  scopes: 'Scopes',
  ipAdress: 'IP Address',
  status: 'Status',
  expireDate: 'Expires Date',
  callbackEndpoint: 'Callback Endpoint',
  authSecret: 'Auth Secret',
  authType: 'Auth Type',
  createdAt: 'Created At',
  actions: 'Actions',
  confirmResetClientSecret: 'Confirm to reset client secret?',
  resetSuccess: 'Client secret reset successfully',
  confirmDeleteClient: 'Confirm to delete this client?',
  deleteSuccess: 'Client deleted successfully',
  buttonEditApiClient: 'Edit API Client',
  clientCreate: 'Client Created'

}
